module.exports = __webpack_public_path__ + "operace-nosu_10_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_10_before.jpg
// module id = 1128
// module chunks = 0